import React from 'react'
import Utils from 'utils/Utils'
import ReactSelect from 'components/common/ReactSelect'
import BlockUI from 'react-block-ui'
import ServicesSelector from 'components/services/ServicesSelector'
import Modal from "react-responsive-modal";


export default class CheckboxEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            groups: props.groups
        }
    }

    handleChange = (event) => {

        const target = event.target;
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        let item = Object.assign({}, this.props.item);

        if (name === "margin-left" || name === "margin-right" || name === "margin-top" || name === "margin-bottom") {
            let type = name.replace("margin-", "");
            let style = Object.assign({}, this.props.item.style);
            let margins = Object.assign({}, style.margins);

            if (value !== null && value.toString().length > 0) {
                margins[type] = parseInt(value);
            }
            else {
                delete margins[type];
            }

            if (Object.keys(margins).length > 0) {
                style.margins = margins;
            }
            else {
                delete style.margins;
            }

            if (Object.keys(style).length > 0) {
                item.style = style;
            }
            else {
                delete item.style;
            }
        }
        else if (name === "text") {
            let data = Object.assign({}, item.data);
            data[name] = value;
            item.data = data;
        }
        else if (name === "assignedGroup") {
            let data = Object.assign({}, item.data);
            data.groupID = value.groupID;
            item.data = data;
        }
        else if (name === "isMulti") {
            let data = Object.assign({}, item.data);
            data.type = value === 1 ? "multi" : "single";
            item.data = data;
        }

        if (this.props.onChange instanceof Function) {
            this.props.onChange(item);
        }
    }

    handleDelete = () => {
        if (this.props.onDelete instanceof Function) {
            this.props.onDelete(this.props.item);
        }
    }


    render() {

        let leftMargin = Utils.getNested(this.props.item, "style", "margins", "left");
        let rightMargin = Utils.getNested(this.props.item, "style", "margins", "right");
        let topMargin = Utils.getNested(this.props.item, "style", "margins", "top");
        let bottomMargin = Utils.getNested(this.props.item, "style", "margins", "bottom");

        const text = Utils.value(Utils.getNested(this.props.item, "data", "text"), "");
        const groupID = Utils.value(Utils.getNested(this.props.item, "data", "groupID"), "");
        const isMulti = Utils.value(Utils.getNested(this.props.item, "data", "type"), "") === "multi";

        return (
            <div className="grid-x grid-padding-x">
                <div className="small-9 cell">
                    <h3>Text Field</h3>
                </div>
                <div className="cell auto text-right">
                    <button className="button alert small" onClick={this.handleDelete}>Delete</button>
                </div>
                <div className="cell small-12 medium-12 large-8">
                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <fieldset className="fieldset">
                                <legend>Properties</legend>
                                <div className="grid-x grid-padding-x">
                                    <div className="small-12 cell">
                                        <span>* Option title</span>
                                        <input type="text" name="text" onChange={this.handleChange} value={text} />
                                    </div>
                                    <div className="small-12 cell">
                                        <span>Group ID</span>
                                        <input type="text" name="groupID" onChange={this.handleChange} value={groupID} disabled/>
                                    </div>
                                    <div className="small-12 cell">
                                        <label className="chkbx-container" style={{display:"inline-block", marginRight: 30}}>
                                            <input className="chkbx" type="checkbox" name="isMulti" onChange={this.handleChange} checked={isMulti} />
                                            <span className="chkmk"></span>
                                        </label>
                                        <label htmlFor="isMulti" className="text-right middle" style={{display: "inline-block"}}>Can select multiple options in the group?</label>
                                    </div>
                                    <div className="small-12 cell">
                                        <span>Assign to existing groupID</span>
                                        <ReactSelect
                                            classNamePrefix="editor"
                                            name="assignedGroup"
                                            className="react-select"
                                            onChange={this.handleChange}
                                            options={this.state.groups}
                                        />
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
                <div className="cell small-12 medium-12 large-4">
                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell small-setts-box">
                            <fieldset className="fieldset">
                                <legend>Margins</legend>
                                <div className="grid-x grid-padding-x">
                                    <div className="small-6 cell">
                                        <span>Left</span>
                                        <input name="margin-left" type="number" placeholder="inherited" min={0} value={leftMargin} onChange={this.handleChange} />
                                    </div>
                                    <div className="small-6 cell">
                                        <span>Top</span>
                                        <input name="margin-top" type="number" placeholder="inherited" min={0} value={topMargin} onChange={this.handleChange} />
                                    </div>
                                    <div className="small-6 cell">
                                        <span>Right</span>
                                        <input name="margin-right" type="number" placeholder="inherited" min={0} value={rightMargin} onChange={this.handleChange} />
                                    </div>
                                    <div className="small-6 cell">
                                        <span>Bottom</span>
                                        <input name="margin-bottom" type="number" placeholder="inherited" min={0} value={bottomMargin} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}